import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { ChevronLeft, ChevronRight, ZoomIn, ZoomOut, Download } from 'lucide-react';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import './PDFViewer.css';

// Set up the worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const API_BASE = process.env.REACT_APP_API_URL || '';

const PDFViewer = ({ fileId }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1.0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fileUrl = `${API_BASE}/api/files/${fileId}`;

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
    setLoading(false);
    setError(null);
  };

  const onDocumentLoadError = (error) => {
    console.error('Error loading PDF:', error);
    setError('Failed to load PDF');
    setLoading(false);
  };

  const changePage = (offset) => {
    setPageNumber(prevPageNumber => {
      const newPageNumber = prevPageNumber + offset;
      if (newPageNumber >= 1 && newPageNumber <= numPages) {
        return newPageNumber;
      }
      return prevPageNumber;
    });
  };

  const changeZoom = (delta) => {
    setScale(prevScale => {
      const newScale = prevScale + delta;
      if (newScale >= 0.5 && newScale <= 3.0) {
        return newScale;
      }
      return prevScale;
    });
  };

  const handleDownload = () => {
    window.open(fileUrl, '_blank');
  };

  return (
    <div className="pdf-viewer">
      <div className="pdf-controls">
        <div className="page-controls">
          <button 
            onClick={() => changePage(-1)} 
            disabled={pageNumber <= 1}
            className="control-button"
          >
            <ChevronLeft size={20} />
          </button>
          <span className="page-info">
            Page {pageNumber} of {numPages || '-'}
          </span>
          <button 
            onClick={() => changePage(1)} 
            disabled={pageNumber >= numPages}
            className="control-button"
          >
            <ChevronRight size={20} />
          </button>
        </div>
        
        <div className="zoom-controls">
          <button 
            onClick={() => changeZoom(-0.2)} 
            disabled={scale <= 0.5}
            className="control-button"
          >
            <ZoomOut size={20} />
          </button>
          <span className="zoom-info">{Math.round(scale * 100)}%</span>
          <button 
            onClick={() => changeZoom(0.2)} 
            disabled={scale >= 3.0}
            className="control-button"
          >
            <ZoomIn size={20} />
          </button>
        </div>
        
        <button onClick={handleDownload} className="control-button download">
          <Download size={20} />
          Download
        </button>
      </div>
      
      <div className="pdf-content">
        {error ? (
          <div className="error">{error}</div>
        ) : (
          <Document
            file={fileUrl}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={onDocumentLoadError}
            loading={<div className="loading">Loading PDF...</div>}
          >
            <Page 
              pageNumber={pageNumber} 
              scale={scale}
              renderTextLayer={true}
              renderAnnotationLayer={true}
            />
          </Document>
        )}
      </div>
    </div>
  );
};

export default PDFViewer;